export const CustomFieldTypes = {
    Birthday: 'birthday',
    Phone: 'phone',
    Company: 'company',
    Address: 'address',
    City: 'city',
    PostalCode: 'postalcode',
    State: 'state',
    Country: 'country',
    Consent: 'consent',
    Custom: 'custom',
} as const;
